export const getWindow = (): Window | null => {
  return typeof window !== 'undefined' ? window : null;
}
